module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a510e2c02febcade2ecc23aa5a96cbd9.png";